import OrdersStore from './OrdersStore'

export default OrdersStore
